module.exports = __webpack_public_path__ + "img/866C5B_544237_B29B8C_AC8F7C-256px.e0a6a9d0.png";